import { hyperdbHandlers } from 'hyperdb-utils';

const handlers = hyperdbHandlers({ namespace: 'PROPERTY_CONTENT' });
export default {
  ...handlers,
  PROPERTY_CONTENT__UPLOAD_PICTURE(state) {
    return { ...state, uploadingPicture: true, errorMessage: null, uploadSuccess: false };
  },
  PROPERTY_CONTENT__UPLOAD_PICTURE_SUCCESS(state, { payload }) {
    const savedPicture = payload;
    return { ...state, savedPicture, uploadingPicture: false, errorMessage: null, uploadSuccess: true };
  },
  PROPERTY_CONTENT__DELETE_PICTURE(state) {
    return { ...state, deletingPicture: true, errorMessage: null, deletePictureSuccess: false };
  },
  PROPERTY_CONTENT__DELETE_PICTURE_SUCCESS(state) {
    return { ...state, deletingPicture: false, errorMessage: null, deletePictureSuccess: true };
  },
  PROPERTY_CONTENT__UPLOAD_PDF(state) {
    return { ...state, uploadingPdf: true, errorMessage: null, uploadPdfSuccess: false };
  },
  PROPERTY_CONTENT__UPLOAD_PDF_SUCCESS(state, { payload }) {
    const savedPdf = payload;
    return { ...state, savedPdf, uploadingPdf: false, errorMessage: null, uploadPdfSuccess: true };
  },
  PROPERTY_CONTENT__DELETE_PDF(state) {
    return { ...state, deletingPdf: true, errorMessage: null, deletePdfSuccess: false };
  },
  PROPERTY_CONTENT__DELETE_PDF_SUCCESS(state) {
    return { ...state, deletingPdf: false, errorMessage: null, deletePdfSuccess: true };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/handlers.js